export default __webpack_public_path__ + "static/media/passport-logo-white-text.50caa5ea.svg";